export const COVER_IMAGE_RATIO = 345 / 245;
export const NATURE_SOUND_COVER_IMAGE_RATIO = 1 / 1;
export const BACKGROUND_IMAGE_RATIO = 375 / 734;
export const ICON_IMAGE_RATIO = 1 / 1;

class ApplicationSettings {
    readonly baseUrl = location.origin;
    private static instance: ApplicationSettings;
    private constructor() {
    }

    readonly localHostUrl = "localhost:20250";

    /** Is localhost */
    get localhost(): boolean {
        return location.host.indexOf('localhost') > -1;
    }

    get socketUrl(): string {
        var prot = location.protocol.indexOf('https') > -1 ? 'wss' : 'ws';
        var host = this.localhost ? this.localHostUrl : location.host;
        return `${prot}://${host}/websocket`;
    };

    static getInstance(): ApplicationSettings {
        if (!ApplicationSettings.instance) {
            ApplicationSettings.instance = new ApplicationSettings();
        }
        return ApplicationSettings.instance;
    }
}

var settings = ApplicationSettings.getInstance();
export default settings;